angular.module('memberPortal').controller('MembershipPlanCtrl', ["$scope", "$state", "$stateParams", "$filter", "$window", "$http", "DataService", "membershipPlans", "membershipPlan", "membership", function($scope, $state, $stateParams, $filter, $window, $http, DataService, membershipPlans, membershipPlan, membership) {
  var baseUrl, loadEzidebitFees, ref, startDateLimitNumber, startDateLimitUnit;
  $scope.data = DataService;
  $scope.currency = DataService.currency;
  $scope.hash = $stateParams.m;
  $scope.membership = membership;
  $scope.membershipPlan = membershipPlan;
  $scope.paymentMethod = ((ref = DataService.member_details.payment_method.data) != null ? ref.attributes : void 0) || DataService.member_details.payment_method;
  $scope.defaultDates = membershipPlan.default_dates;
  $scope.pageParams = {
    startDate: $scope.defaultDates.start_date || DataService.gym_today
  };
  baseUrl = `/websites/${DataService.domain}/members/`;
  $scope.minDate = moment(DataService.gym_today).toDate();
  startDateLimitNumber = membershipPlan.member_portal_start_date_limit_number;
  startDateLimitUnit = membershipPlan.member_portal_start_date_limit_unit;
  $scope.maxDate = startDateLimitNumber && startDateLimitUnit ? moment(DataService.gym_today).add(startDateLimitNumber, startDateLimitUnit).toDate() : moment(DataService.gym_today).add(364, 'days').toDate();
  $scope.startDateCanBeChanged = !membershipPlan.specified_start_date && membershipPlan.allow_customer_to_choose_start_date_on_member_portal;
  $scope.onDateChange = function() {
    var params, url;
    params = {
      gid: $scope.data.gym_id,
      purchase_date: $scope.pageParams.startDate
    };
    url = `/membership_defaults/${membershipPlan.uuid}`;
    return $http.get(url, {
      params: params
    }).then(function(response) {
      return $scope.defaultDates = response.data;
    });
  };
  if (!DataService.member_details.can_purchase_memberships) {
    $state.go('memberPortal.bookings', {
      m: $scope.getHash()
    });
  }
  $scope.showMembershipAlreadyExistsMessage = function() {
    var expirationDate, today;
    if (!membership) {
      return false;
    }
    expirationDate = moment(membership.expiration_date);
    today = moment(DataService.member_details.gym_today);
    return membership.expiration_date && expirationDate.subtract(3, 'days').isAfter(today);
  };
  $scope.isCard = function(paymentMethod) {
    if (!paymentMethod) {
      return;
    }
    return paymentMethod.card_expiration || paymentMethod.exp_year || paymentMethod.payment_method === 'credit_card';
  };
  $scope.isBankAccount = function(paymentMethod) {
    if (!paymentMethod) {
      return;
    }
    return paymentMethod.payment_method === 'bank_account' || paymentMethod.card_brand === 'ACH';
  };
  loadEzidebitFees = function() {
    if ($scope.data.member_details.gym_payment_provider !== 'ezidebit' || (!$scope.isCard($scope.paymentMethod) && !$scope.isBankAccount($scope.paymentMethod)) || $scope.isFreeMembership) {
      return;
    }
    return $http.get(`/fee_schedules?gym_id=${$scope.data.gym_id}`).then(function(respose) {
      return $scope.fees = respose.data.fees;
    });
  };
  loadEzidebitFees();
  $scope.isFreeMembership = !parseFloat(membershipPlan.cost_upfront) && !parseFloat(membershipPlan.cost_repeat);
  $scope.isUpfront = parseFloat(membershipPlan.cost_upfront) > 0 && !parseFloat(membershipPlan.cost_repeat);
  $scope.isRecurring = parseFloat(membershipPlan.cost_repeat) > 0 && !parseFloat(membershipPlan.cost_upfront);
  $scope.isUpfrontAndRecurring = parseFloat(membershipPlan.cost_upfront) > 0 && parseFloat(membershipPlan.cost_repeat) > 0;
  $scope.formattedDate = function(date) {
    return moment(date).format('D MMM, YYYY');
  };
  $scope.getHash = function() {
    return $stateParams.hash || $stateParams.m;
  };
  return $scope.purchase = function() {
    var memberUrl, message, params, url;
    message = `Are you sure you want to purchase: ${membershipPlan.label}?`;
    if ($window.confirm(message)) {
      $scope.pageParams.isLoading = true;
      url = `${baseUrl}memberships`;
      memberUrl = `${baseUrl}members/${DataService.member_details.id}`;
      params = {
        membership_plan_id: membershipPlan.id,
        start_date: $scope.pageParams.startDate
      };
      return $http.post(url, params).then(function() {
        $scope.isPurchased = true;
        $scope.pageParams.error = void 0;
        $scope.pageParams.isLoading = false;
        return $http.get(memberUrl).then(function(response) {
          return DataService.member_details = response.data;
        });
      }, function(response) {
        $scope.pageParams.isLoading = false;
        return $scope.pageParams.error = response.data.error;
      });
    }
  };
}]);
